import React, { useState, useRef, useEffect } from 'react';
import { FileText, Download, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const DOCUMENTOS_OSC = [
  {
    nome: 'CheckList de Documentos Necessários',
    arquivo: 'CheckList_Documentos_Necessarios_OSC.docx',
    descricao: 'Lista completa de documentos necessários para OSC'
  },
  {
    nome: 'Modelo de Declaração Lei 13.019',
    arquivo: 'Modelo_de_Declaracao_Lei13019_OSC.docx',
    descricao: 'Modelo de declaração conforme Lei 13.019/2014'
  },
  {
    nome: 'Modelo de Ofício',
    arquivo: 'Modelo_Oficio_OSC.docx',
    descricao: 'Modelo padrão de ofício para OSC'
  },
  {
    nome: 'Modelo de Projeto Técnico',
    arquivo: 'Modelo_Projeto_Tecnico_OSC.doc',
    descricao: 'Modelo de projeto técnico para parcerias'
  },
  {
    nome: 'Modelo de Plano de Trabalho',
    arquivo: 'Modelo-Plano-de-Trabalho_OSC.doc',
    descricao: 'Modelo de plano de trabalho para parcerias'
  }
];

export default function DocumentosDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleDownload = (arquivo) => {
    const link = document.createElement('a');
    link.href = `/${arquivo}`;
    link.download = arquivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Botão principal */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-all duration-200 shadow-md hover:shadow-lg"
      >
        <FileText className="w-5 h-5" />
        <span className="hidden sm:inline font-medium">Documentos OSC</span>
        <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {/* Dropdown */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute right-0 mt-2 w-80 sm:w-96 bg-white rounded-lg shadow-xl border border-slate-200 z-50 overflow-hidden"
          >
            {/* Header do dropdown */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-4 py-3">
              <h3 className="text-white font-semibold text-sm flex items-center gap-2">
                <FileText className="w-4 h-4" />
                Modelos de Documentos para OSC
              </h3>
              <p className="text-blue-100 text-xs mt-1">
                Clique para fazer o download
              </p>
            </div>

            {/* Lista de documentos */}
            <div className="max-h-96 overflow-y-auto">
              {DOCUMENTOS_OSC.map((doc, index) => (
                <button
                  key={index}
                  onClick={() => handleDownload(doc.arquivo)}
                  className="w-full px-4 py-3 hover:bg-blue-50 transition-colors duration-150 border-b border-slate-100 last:border-b-0 text-left group"
                >
                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                      <Download className="w-5 h-5 text-blue-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-semibold text-slate-800 group-hover:text-blue-600 transition-colors">
                        {doc.nome}
                      </h4>
                      <p className="text-xs text-slate-500 mt-0.5 line-clamp-1">
                        {doc.descricao}
                      </p>
                      <p className="text-xs text-slate-400 mt-1 font-mono">
                        {doc.arquivo}
                      </p>
                    </div>
                  </div>
                </button>
              ))}
            </div>

            {/* Footer do dropdown */}
            <div className="bg-slate-50 px-4 py-2 border-t border-slate-200">
              <p className="text-xs text-slate-600 text-center">
                Total de {DOCUMENTOS_OSC.length} documentos disponíveis
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
